module.exports = __webpack_public_path__ + "assets/img/step1-sz.efe4debe.png";